module.exports = __webpack_public_path__ + "img/GPB_Top10_2019-2.fd78904c.png";